/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesnoresults2Inputs */

const zh_learn_mistakesnoresults2 = /** @type {(inputs: Learn_Mistakesnoresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有匹配的错题`)
};

const en_learn_mistakesnoresults2 = /** @type {(inputs: Learn_Mistakesnoresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching mistakes`)
};

const es_learn_mistakesnoresults2 = /** @type {(inputs: Learn_Mistakesnoresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron errores`)
};

/**
* | output |
* | --- |
* | "No matching mistakes" |
*
* @param {Learn_Mistakesnoresults2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesnoresults2 = /** @type {((inputs?: Learn_Mistakesnoresults2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesnoresults2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesnoresults2(inputs)
	if (locale === "en") return en_learn_mistakesnoresults2(inputs)
	return es_learn_mistakesnoresults2(inputs)
});
export { learn_mistakesnoresults2 as "learn_mistakesNoResults" }